// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import { firestore } from 'firebase'
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators'
import { firebaseAction } from 'vuexfire'
import { rdb } from '../../firebase/init'
import { MessageType } from '../../types'
import store from '..'

@Module({ name: 'messages', store, dynamic: true })
export default class Message extends VuexModule {
  managerMessages:MessageType[] = []

  groupMessages:MessageType[] = []

  announcements:MessageType[] = []

  @Action
  bindMessages() {
    const managerAction = firebaseAction(({ bindFirebaseRef }) => bindFirebaseRef('managerMessages', rdb.ref(`locations/${store.getters.location}/messages/${store.getters.uid}`))) as Function
    const groupAction = firebaseAction(({ bindFirebaseRef }) => bindFirebaseRef('groupMessages', rdb.ref(`locations/${store.getters.location}/messages/group`))) as Function
    const annoucementsAction = firebaseAction(({ bindFirebaseRef }) => bindFirebaseRef('announcements', rdb.ref(`locations/${store.getters.location}/messages/announcements`))) as Function
    return Promise.all([managerAction(this.context), groupAction(this.context), annoucementsAction(this.context)])
  }
}
